import React, { Suspense } from 'react';

import { Spin } from 'components/Spin';

interface AppSuspenseProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Simplified Suspense component
 * The initialization loading is managed by InitializationProvider
 */
const AppSuspense: React.FC<AppSuspenseProps> = ({ children, fallback = <Spin /> }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

export default AppSuspense;
